import {Component} from '@angular/core';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {Router, RouterOutlet} from '@angular/router';
import {AsyncPipe} from '@angular/common';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {HeadTitlePageComponent} from './shared/components/head-title-page/head-title-page.component';
import {UserLoginService} from './shared/services/user-login.service';
import {environment} from '../environments/environment';
import {getBrowserLang, TranslocoService} from '@jsverse/transloco';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, MatProgressBarModule, MatProgressSpinnerModule, AsyncPipe, HeadTitlePageComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    language: string;

    constructor(
        private translocoService: TranslocoService,
        private _userLoginService: UserLoginService,
        public _loader: LoadingBarService,
        private _router: Router,
    ) {
        if (this._userLoginService.getLanguage()) {
            this.language = this._userLoginService.getLanguage();
        } else {
            const userLang = getBrowserLang();
            switch (userLang) {
                case 'it':
                    this.language = 'it';
                    break;
                case 'es':
                    this.language = 'es';
                    break;
                case 'pt':
                    this.language = 'pt';
                    break;
                default:
                    this.language = 'en';
                    break;
            }
        }
        this._userLoginService.setLanguage(this.language, true);
        this.translocoService.setDefaultLang(this.language);
        this.translocoService.setActiveLang(this.language);

        switch (this._userLoginService.getTheme()) {
            case this._userLoginService.DARK_THEME:
                this._userLoginService.setTheme(this._userLoginService.DARK_THEME);
                break;
            case this._userLoginService.LIGHT_THEME:
                this._userLoginService.setTheme(this._userLoginService.LIGHT_THEME);
                break;
            default:
                this._userLoginService.setTheme(this._userLoginService.DARK_THEME);
        }

        if (!window.location.href.includes('/#/' + environment.baseAdminPath) && !window.location.href.includes('/#/' + environment.baseAppPath)) {
            if (window.location.hostname.includes(environment.administratorDomain)) {
                this._router.navigate(['/' + environment.baseAdminPath]).then();
            } else {
                this._router.navigate(['/' + environment.baseAppPath]).then();
            }
        }

    }
}
